import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { servicesAPI, contentAPI } from '../services/api';
import { appRoutes } from '../routes/config';
import './Sitemap.css';

const Sitemap = () => {
  const [services, setServices] = useState([]);
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [servicesRes, pagesRes] = await Promise.all([
          servicesAPI.getAllServices(),
          contentAPI.getPages(),
        ]);

        const servicesList = servicesRes.data.results || servicesRes.data || [];
        setServices(Array.isArray(servicesList) ? servicesList.slice(0, 50) : []);
        setPages(pagesRes.data.results || pagesRes.data || []);
      } catch (error) {
        console.error('Failed to load sitemap data', error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const primaryPages = appRoutes.filter((route) => route.includeInSitemap && route.path && !route.path.includes(':'));

  const canonicalPagePaths = {
    home: '/',
    about: '/about',
    services: '/services',
    contact: '/contact',
    book: '/book',
    pricing: '/services',
    'how-it-works': '/services',
  };

  const resolvePagePath = (slug) => canonicalPagePaths[slug] || `/page/${slug}`;

  return (
    <>
      <Helmet>
        <title>Sitemap - Automotive Care</title>
        <meta
          name="description"
          content="Complete sitemap of Automotive Care website. Find all our services, pages, and information easily."
        />
      </Helmet>

      <div className="sitemap-page">
        <div className="sitemap-hero">
          <div className="container">
            <h1>Sitemap</h1>
            <p>Navigate our website easily with this complete overview of all pages</p>
          </div>
        </div>

        <div className="sitemap-content">
          <div className="container">
            {loading ? (
              <div className="spinner" />
            ) : (
              <div className="sitemap-grid">
                {/* Main Pages */}
                <div className="sitemap-section">
                  <h2>Main Pages</h2>
                  <ul>
                    {primaryPages.map((page) => (
                      <li key={page.path}>
                        <Link to={page.path}>{page.label || page.path}</Link>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Services */}
                {services.length > 0 && (
                  <div className="sitemap-section">
                    <h2>Our Services</h2>
                    <ul>
                      {services.map((service) => (
                        <li key={service.slug}>
                          <Link to={`/services/${service.slug}`}>
                            {service.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* CMS Pages */}
                {pages.length > 0 && (
                  <div className="sitemap-section">
                    <h2>Information Pages</h2>
                    <ul>
                      {pages.map((page) => (
                        <li key={page.slug}>
                          <Link to={resolvePagePath(page.slug)}>
                            {page.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Sitemap;
